<template>
    <div class="price-specification">
        <PriceSpecificationVehicle :product="product" />

        <Divider color="lightGrey" bottomMargin="xl" topMargin="xl" thickness="1" />

        <PriceSpecificationRow
            class="total"
            :price="totalPrice"
            :description="t({ key: 'checkout.total_to_pay' })" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';
    import { mapTransferPrice } from '../../PriceBreakdown/map/transfer';
    import Divider from '@ui/components/Divider/Divider.vue';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import PriceSpecificationVehicle from './PriceSpecificationVehicle.vue';

    export default defineComponent({
        name: 'PriceSpecificationTransfer',
        methods: { t },
        components: { PriceSpecificationRow, PriceSpecificationVehicle, Divider },
        props: {
            product: {
                type: Object as PropType<TransferProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const totalPrice = computed(() => mapTransferPrice(product));

            return {
                totalPrice,
            };
        },
    });
</script>

<style lang="scss">
    @forward '@/components/shared/PriceSpecification/Transfer/PriceSpecificationTransfer.scss';
</style>
